import React, { useContext } from "react"
import { graphql, useStaticQuery } from "gatsby";
import useLiveData from 'hooks/useLiveData';
import ImageSlider from 'components/ImageSlider';
import { PersonalizationContext } from 'components/Personalization/PersonalizationContext';

const ImageSliderProvider = (props) => {
	const { matchAudience } = useContext(PersonalizationContext);
	const data = useStaticQuery(graphql`
		query allSmartTagsImageSliders {
			allSmartTagsImageSlider {
				edges {
					node {
						id
						background
				        backgroundImage
						backgroundProps
						subtitle
						title
						description
						linkText
						link
						padding
						flush
						layout
						Gallery {
							object {
								id
								slides {
									image
									link
									linkText
									subtitle
									title
								}
							}
						}
						Audience {
							...AudienceRelationshipDetailsFragment
						}
					}
				}
			}
		}
	`);
	const { response } = useLiveData({
		namespace: 'SmartTags',
		model: 'ImageSlider',
		method: 'all',
		graphqlKey: 'allSmartTagsImageSlider',
		apiParams: {
			archived: false,
			approved: true,
			deleted: false,
			_join: 'Gallery'
		},
		staticData: data,
	});
	if (response.data.length === 0)return null;
	let attr;
	for (let item of response.data) {
		if (item.id === props.id)attr = item;
	}
	if (!!attr && attr.hasOwnProperty('Audience') && attr?.Audience) {
		if (!matchAudience(attr?.Audience)) {
			return null;
		}
	}
	if (!attr)return null;

	let gallery = attr?.Gallery[0];

	return (
		<ImageSlider slider={gallery?.object} layout={attr?.layout ?? 'fullwidth'} {...attr} matchAudience={matchAudience} />
	)
};

export default ImageSliderProvider;